/**
 * Shared formatting for "In X carts" urgency experiment copy.
 *
 * @todo CHAIR-19176 CHAIR-19177 CHAIR-19415 Remove after test
 */

import { getAmplitudeExperimentFlagMap } from 'chairisher/context/experiments';
import { exposeExperiment, isExperimentVariantB } from 'chairisher/thirdparty/experiments';

/**
 * Formats a count for urgency display, capping values above 20.
 *
 * @param {number} count Raw interaction count
 * @returns {string} Display string for the count
 */
export function formatUrgencyCount(count) {
    return count > 20 ? '20+' : String(count);
}

/**
 * Formats the "In X cart(s)" urgency label for a count.
 *
 * @param {number} count Number of other carts containing this product
 * @returns {string} Label text, or an empty string when count is falsy
 */
export function formatInNumCartsString(count) {
    return count ? `In ${formatUrgencyCount(count)} cart${count > 1 ? 's' : ''}` : '';
}

/**
 * Fills elements marked with data-num-other-carts-in.
 *
 * Assumes the server already decided whether to render the markup (e.g. PLP CHAIR-19176 bucket check).
 *
 * @param {Document|Element=} root Root element to search within
 */
export function populateInNumCartsLabels(root = document) {
    const container = root instanceof Element ? root : document;
    const elements = container.querySelectorAll('[data-num-other-carts-in]');

    // @todo CHAIR-19415 Remove after test - expose only when urgency markup is present
    if (elements.length) {
        exposeExperiment(getAmplitudeExperimentFlagMap().ANONYMOUS_IN_NUM_CART);
    }

    elements.forEach((el) => {
        const count = parseInt(el.getAttribute('data-num-other-carts-in'), 10);
        const text = formatInNumCartsString(count);

        if (text) {
            el.replaceChildren(document.createTextNode(text));
        }

        const parent = el.closest('.js-urgency-badge');
        if (parent) {
            parent.classList.remove('hidden');
        }
    });
}

/**
 * Mini-cart (CHAIR-19177): gate on variant B, then populate labels.
 *
 * isExperimentVariantB also fires the experiment exposure event.
 *
 * @param {Document|Element=} root Root element to search within
 */
export function renderMinicartInNumCartsLabels(root = document) {
    const container = root instanceof Element ? root : document;

    if (isExperimentVariantB(getAmplitudeExperimentFlagMap().MINICART_IN_NUM_CART)) {
        populateInNumCartsLabels(container);
    } else {
        container.querySelectorAll('.js-cart-item-in-num-carts[data-num-other-carts-in]').forEach((el) => {
            el.remove();
        });
    }
}
